<div mat-flat-button class="formclose" align="right" ><img src="assets/img/icons/forma-11.png" (click)="closeRepositoryForm()"></div>
<div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
    <div class="loginbox">
        <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
            <form [formGroup]="Repository" class="example-form">
                
                    <mat-form-field class="example-full-width" style="width:100%">
                        <mat-label>Enter the repository name</mat-label>
                        <input (keypress)="handleInput($event)" matInput formControlName="folderName" value="">
                    </mat-form-field>
                    <mat-error style="padding-top:2px" *ngIf="validator.isfolderName">Please enter the folder name</mat-error>
              


                    <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
                        <span class="flabel">Drag files here</span>
                        <!--Loader  -->
                        <img *ngIf="Rloader" align="right" src="assets/img/spinner.svg">
                        <input type="file" style="display: none" (change)="onSelectFile($event)" #fileInput multiple>
                        <span class="Rounded-Rectangle-1" mat-button (click)="fileInput.click()">
                            <span><img style="padding: 20px" src="assets/img/icons/UploadBlue.png">{{this.logoPreview}}</span>
                        </span>
                        <img *ngFor='let url of urls' [src]="url" height="50"> <br />

                        <button *ngIf="!Rloader" class="btn" align="right" mat-button (click)="createtemplate()">Upload</button>
                    </div>


                <!-- <div *ngIf="!files.length" class="col-12 rmpm dropzone" appDrag (files)="filesDropped($event)">
        <div class="text-wrapper">
            <div class="centered">Drop your file here!</div>
        </div>
    </div>
    <div *ngFor="let file of files">
        <img *ngIf="file" [src]="file.url">
    </div> -->


                <div class="col-sm-12 col-xs-12 col-md-3 col-lg-3">
                </div>

            </form>
        </div>
    </div>



    <!-- <div id="drop-area">
        <form class="my-form">
            <p>Upload multiple </p>
            <input type="file" id="fileElem" multiple accept="image/*" onchange="handleFiles(this.files)">
            <label class="button" for="fileElem">Select some files</label>
        </form>
    </div> -->
</div>